import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

export const PublicGuard = async (route: any) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    const routePath = route.routeConfig?.path || '';
    if (routePath.startsWith('email-confirmation') || routePath.startsWith('password-reset') || routePath.startsWith('profile-delete-help')) {
      return true;
    }
  } catch (error) {
    console.error('Error checking route path:', error);
  }

  let user: any;
  try {
    user = await firstValueFrom(authService.currentUser());
    if (user && user.uid) {
      const claims = await authService.getCustomClaims();
      if (claims && claims.role && (claims.role === 'TEACHER' || claims.role === 'ADMINISTRATOR')) {
        return router.navigateByUrl('/select-subject');
      }
    }
  } catch (error) {
    console.error('Authentication error:', error);
  }
  return true;
};
